import Vue from "vue";
import Router from "vue-router";
import Main from "@/components/gamebox/Main.vue";
import Profile from "@/components/gamebox/Profile.vue";
import HotPicks from "@/components/gamebox/HotPicks.vue";
import Popular from "@/components/gamebox/Popular.vue";
import Subcategory from "@/components/gamebox/Subcategory.vue";
import DetailPage from "@/components/gamebox/DetailPage.vue";
import Login from "../components/authentication/gamebox/Login.vue";
import PrivacyPolicy from "../components/gamebox/PrivacyPolicy.vue";
import Terms from "../components/gamebox/Terms.vue";
Vue.use(Router);

export default new Router({
  mode: "history",
  hash: false,
  history: true,
  routes: [
    {
      path: "/home",
      name: "Main",
      component: Main,
      children: [
        {
          path: "/home/:token"
        }
      ]
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      children: [
        {
          path: "/logout"
        }
      ]
    },
    {
      path: "/popular",
      name: "HotPicks",
      component: HotPicks,
      children: [
        {
          path: "/hotpicks/:token"
        }
      ]
    },
    {
      path: "/hotpicks",
      name: "Popular",
      component: Popular,
      children: [
        {
          path: "/popular/:token"
        }
      ]
    },
    {
      path: "/privacy",
      name: "PrivacyPolicy",
      component: PrivacyPolicy,
      children: [
        {
          path: "/privacy/:token"
        }
      ]
    },
    {
      path: "/detail/:id",
      name: "DetailPage",
      component: DetailPage,
      children: [
        {
          path: "/detail/:id/:token"
        }
      ]
    },
    {
      path: "/terms",
      name: "Terms",
      component: Terms,
      children: [
        {
          path: "/terms/:token"
        }
      ]
    },
    {
      path: "/profile",
      name: "Profile",
      component: Profile,
      children: [
        {
          path: "/profile/:token"
        }
      ]
    },

    {
      path: "/subcategory/:subcategory",
      name: "Subcategory",
      component: Subcategory,
      children: [
        {
          path: "/subcategory/:subcategory/:token"
        }
      ]
    },
    {
      path: "/:token",
      name: "Main",
      component: Main
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/gamebox.js